import { Grid, TextField, Typography } from '@mui/material';
import { DMSLocationInput } from 'adoms-common-lib';
import React from 'react';

type DmsFieldKey = keyof DMSLocationInput;

type DmsCoordinateInputProps = {
    caption: string
    value: DMSLocationInput
    directionHelper: string
    textFieldSx?: any
    onChangeField: (field: DmsFieldKey, value: string) => void
}

export const DmsCoordinateInput: React.FC<DmsCoordinateInputProps> = (props) => {
    return (
        <Grid container spacing={0.5}>
            <Grid item xs={12}>
                <Typography variant="caption" color="textSecondary" sx={{ mb: 1, display: 'block' }}>
                    {props.caption}
                </Typography>
            </Grid>
            <Grid item xs={2.5}>
                <TextField
                    label="度"
                    value={String(props.value.degrees ?? '')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={props.textFieldSx}
                    onChange={(event) => props.onChangeField('degrees', event.target.value)}
                />
            </Grid>
            <Grid item xs={2.5}>
                <TextField
                    label="分"
                    value={String(props.value.minutes ?? '')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={props.textFieldSx}
                    onChange={(event) => props.onChangeField('minutes', event.target.value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextField
                    label="秒"
                    value={String(props.value.seconds ?? '')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={props.textFieldSx}
                    onChange={(event) => props.onChangeField('seconds', event.target.value)}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    label="方位"
                    value={String(props.value.direction ?? '')}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={props.textFieldSx}
                    helperText={props.directionHelper}
                    onChange={(event) => props.onChangeField('direction', event.target.value)}
                />
            </Grid>
        </Grid>
    );
};